<template>
  <div :id='id' class="trendChart">
  </div>
</template>

<script>
  import * as echarts from 'echarts';

export default {
    name: 'trendChart',
    components: {
    },
    props: {
        chartData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            id: this.chartData.id,
            lineColor: '',
            option: {},
            myChart: null,
        };
    },
    methods: {
        refresh() {
            this.myChart.setOption(this.option);
        },
        initOptions(data) {
            this.option = {
                backgroundColor: '#ffffff',
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        lineStyle: {
                            color: '#57617B',
                        },
                    },
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '5%',
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: data.xAxisData,
                    axisPointer: {
                        show: true,
                    },
                    axisLine: {
                        show: false,
                      lineStyle: {
                        color: '#999999',
                        opacity: 0.2,
                      },
                    },
                    axisTick: {
                        show: true,
                        length: 25,
                        lineStyle: {
                            color: '#999999',
                            opacity: 0.2,
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#999999',
                            opacity: 0.2,
                        },
                    },
                },
                yAxis: [{
                    type: 'value',
                    name: '',
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        show: false,
                    },
                    axisLabel: {
                        margin: 10,
                        textStyle: {
                            fontSize: 14,
                            color: '#999999',
                        },
                    },
                    splitLine: {
                        show: false,
                    },
                }],
                series: [{
                    name: '文件数',
                    type: 'line',
                    smooth: true,
                    symbol: 'circle',
                    symbolSize: 5,
                    showSymbol: false,
                    lineStyle: {
                        normal: {
                            width: 1,
                        },
                    },
                    areaStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(0, 136, 212, 0.3)',
                            }, {
                                offset: 0.8,
                                color: 'rgba(0, 136, 212, 0)',
                            }], false),
                            shadowColor: 'rgba(0, 0, 0, 0.1)',
                            shadowBlur: 10,
                        },
                    },
                    itemStyle: {
                        normal: {
                            color: 'rgb(0,136,212)',
                            borderColor: 'rgba(0,136,212,0.2)',
                            borderWidth: 12,

                        },
                    },
                    data: data.data,
                }],
            };
        },
    },
    watch: {
        chartData: {
            handler(newVal) {
                this.initOptions(newVal);
                this.myChart.setOption(this.option);
            },
            deep: true,
        },
    },
    mounted() {
        this.myChart = echarts.init(document.getElementById(this.chartData.id));
        this.initOptions(this.chartData);
        this.myChart.setOption(this.option);
    },
};
</script>

<style scoped lang='stylus' rel='stylesheet/stylus'>
  @import '~common/stylus/variable'
  @import '~common/stylus/mixin'
  .trendChart
    height 100%
    width 100%
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/consoleLab/myapp/app-trend-chart.vue